import { useEffect, useRef, useState } from 'react'
import useVirtualKeyboard from './useVirtualKeyboard'

export const useScrollToInputOnVirtualKeyboardOpened = <T extends Element>() => {
  const [keyboardVisibility, setKeyboardVisibility] = useState('hidden')
  const ref = useRef<T>(null)
  const [shouldScrollTo, setShouldScrollTo] = useState(false)
  useVirtualKeyboard(setKeyboardVisibility)

  useEffect(() => {
    if (ref.current && shouldScrollTo) {
      setTimeout(() => {
        ref.current!.scrollIntoView({ behavior: 'smooth', block: 'center' })
      }, 600)
      setShouldScrollTo(false)
    }
  }, [shouldScrollTo])

  useEffect(() => {
    if (keyboardVisibility === 'visible') {
      setShouldScrollTo(true)
    }
  }, [keyboardVisibility, setShouldScrollTo])

  return {
    scrollToRef: ref,
    setShouldScrollTo,
  }
}
